export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_GDM_7.67ce4516.jpg";